import { BaseService, Service } from "/@/cool";
@Service("wlAttribute")
class WlAttribute extends BaseService {}
export default WlAttribute;
